import { WindowMetrics } from "../utilities/window-metrics.js";
import { ZoomableImage } from "../utilities/zoomable-image.js";

export class ComplementSystem {
    constructor(parameters) {
        var t = this;
        let root = document.documentElement;

        // Setup enlargable images
        let enlargableImages = document.querySelectorAll(".enlargable-image");
        for (let i = 0; i < enlargableImages.length; i++)
            new ZoomableImage(enlargableImages[i]);

        // let's move the red featured-slab div to tuck under
        // the gray callout by updating the css variables
        function overlapCallout() {
            var calloutHeight = document.querySelector('.callout').getBoundingClientRect().height,
                extraPadding,
                calloutMargin = (calloutHeight / 2);

            if (WindowMetrics.isMobile()) {
                extraPadding = 60;
            }
            else {
                extraPadding = 74;
            }
            
            root.style.setProperty('--complement-margin', '-' + calloutMargin + 'px');
            root.style.setProperty('--complement-padding', calloutMargin + extraPadding + 'px');

        }

        window.addEventListener('DOMContentLoaded', (event) => {
            overlapCallout();
        });

        window.addEventListener('resize', (event) => {
            overlapCallout();
        });

    }
}